"use client";

import { memo } from "react";

import { useToast } from "@/components/ui/use-toast";
import { ga4Share } from "@/lib/analytics/ga4-ecommerce";

import ShareIcon from "@/components/icons/Share";

type Props = {
	blogId: string;
};

function FeedbackInfoSection({ blogId }: Props) {
	const { toast } = useToast();

	const onSharePressed = () => {
		const shareLink = `${process.env.NEXT_PUBLIC_FRONTEND_URI}/blogs/${blogId}`;
		navigator.clipboard.writeText(shareLink);
		ga4Share({ method: "copy_link", content_type: "blog", item_id: blogId });
		toast({ title: "Success", description: "Link copied successfully!" });
	};

	return (
		<div className="flex justify-end text-sm font-medium text-secondary">
			<button
				type="button"
				onClick={onSharePressed}
				className="inline-flex items-center gap-2"
			>
				<ShareIcon className="size-4 sm:size-5" />
				<span>Share</span>
			</button>
		</div>
	);
}

export default memo(FeedbackInfoSection, (oldProps, newProps) => {
	return newProps.blogId === oldProps.blogId;
});
